<template>
  <div class="login">
    <Truck/>
    <Login/>
  </div>
</template>

<script>
import Truck from '../components/base/Truck.vue';
import Login from '../components/session/Login.vue';

export default {
  name: 'ViewLogin',
  components: {
    Truck,
    Login,
  },
};
</script>

<style lang="scss" scoped>
  .login {
    max-width: 400px;
    margin: 3vh auto 0;
  }
</style>
